import { callApi } from '@/apis';
import TIM, { EVENT } from 'tim-js-sdk';
import { init as initIM, IMLogin, onEvent, setReadMessage } from '@shared/common/helper/IMSDK';
import { makeAutoObservable, runInAction } from 'mobx';
import { rootStore } from '@/stores';
import { AuthStore } from '@/stores/modules/auth/AuthStore';
import { Conversation, Message } from '@shared/common/helper/type-tim-sdk';
import { ConversationStore } from '@sure-medical/components-pc/services/IM/conversationBox';

export class IMBaseStore {
  /** 会话列表 */
  conversationList?: Conversation[] = undefined;
  /** 最新收到的消息 */
  newMessage?: Message[];
  /** 是否已经初始化 */
  isInit = false;
  /** 未读对话 */
  unReadNum = 0;
  constructor() {
    makeAutoObservable(this);
  }

  get AuthStore() {
    return rootStore.getStore(AuthStore);
  }

  get ConversationStore() {
    return rootStore.getStore(ConversationStore);
  }

  /** 登录IM */
  async loginIM() {
    const userId = this.AuthStore.loginSession?.userId;
    if (!userId) {
      throw new Error('请先登录');
    }

    const SDKAppID = await this.getSDKAppId();
    initIM({ SDKAppID: SDKAppID!, logLevel: 1 });
    const userSig = await this.getUserSig(userId);
    // 监听初始化
    this.initOnEvent();
    // 使用主账号登录
    await IMLogin({ userID: userId, userSig: userSig! });
  }

  /** 初始化监听事件 */
  initOnEvent() {
    // 只执行一次监听
    if (this.isInit) {
      return;
    }
    // 监听新消息
    onEvent({
      eventType: EVENT.MESSAGE_RECEIVED,
      handler: (res: { data: Message[] | undefined }) => {
        // console.log('IM新消息', res.data);
        runInAction(() => {
          this.newMessage = res.data;
          const conversationID = this.ConversationStore.singleChat
            ? `C2C${this.ConversationStore.conversationId}`
            : `GROUP${this.ConversationStore.conversationId}`;
          const messageList = this.newMessage?.filter((message) => {
            return message.conversationID === conversationID;
          });
          if (messageList?.length) {
            setReadMessage({ conversationID });
          }
          messageList?.forEach((item) => {
            this.ConversationStore.recordList.push({
              ...item,
              // avatar: this.ConversationStore?.groupProfile.avatar || defaultImg.src,
              // time: item.time * 1000,
            });
          });
          this.ConversationStore.newMessage = messageList;
        });
      },
    });
    // 监听会话列表变更
    onEvent({
      eventType: EVENT.CONVERSATION_LIST_UPDATED,
      handler: (res: { data: Conversation[] | undefined }) => {
        runInAction(() => {
          this.conversationList = res.data;
          const unReadNumList = res.data?.map((item) => {
            return [TIM.TYPES.CONV_GROUP, TIM.TYPES.CONV_C2C].includes(item.type) ? item.unreadCount : 0;
          });
          if (unReadNumList?.length) {
            this.unReadNum = unReadNumList.reduce((pre, current) => {
              return pre + current;
            });
            this.saveDoctorUnRead({
              doctorUserId: this.AuthStore.loginSession?.userId ?? '',
              unreadMsgNums: this.unReadNum,
            });
          }
        });
      },
    });
    this.isInit = true;
  }

  /** 获取sdkappid */
  async getSDKAppId() {
    const resp = await callApi('/im/sdk-app-id', 'get');
    if (resp.error) {
      console.error('获取sdkappid失败');
      return;
    }
    return resp.data;
  }

  /** 获取userSig */
  async getUserSig(userId: string) {
    const resp = await callApi('/im/user-sig/{userId}', 'get', {
      urlParams: {
        userId,
      },
    });
    if (resp.error) {
      console.error('获取userSig失败');
      return;
    }
    return resp.data;
  }
  /** 保存管理师未读消息数 */
  async saveDoctorUnRead({ doctorUserId, unreadMsgNums }: { doctorUserId: string; unreadMsgNums: number }) {
    const resp = await callApi('/doctor/save/unread-im-nums', 'post', {
      data: {
        doctorUserId,
        unreadMsgNums,
      },
    });
    if (resp.error) {
      console.error(`存管理师未读消息报错:${resp.error.errMsg}`);
      return;
    }
  }
}
